import styled from "styled-components";

export const StyledNavbar = styled.nav`
  display: flex;
  color: white;
  align-items: flex-start;
  width: 100%;
  justify-content: space-between;
  background: #000;
  z-index: 99999999;
  min-height: 72px;

  position: sticky;
  top: 0px;
  .branding {
    margin: auto;
    margin-left: 30px;
  }
  a {
    color: white;
  }
  .logo {
    width: 300px;
    max-width: 386px;
    padding-left: 0px;
    padding-top: 30px;
    padding-bottom: 30px;
  }
  .pages {
    display: flex;
    padding-top: 40px;
    padding-right: 20px;
    background: #fff;
  }

  .page {
    text-transform: capitalize;
    margin: 0px 10px;
  }

  .page.login {
    color: #8733ff;
  }

  .page.login:hover {
    color: #6f0bd9;
  }

  .pages a {
    text-decoration: none;
    font-family: sofia-pro,sans-serif;
    font-size: 18px;
    letter-spacing: 2px;
  }

  .pages a:hover {
    color: #6f0bd9;
  }

  .navTogglebtnOpen,
  .navTogglebtnClose {
    display: none;
    margin: 0px 10px auto auto;
    cursor: pointer;
    background: #fff;
    color: #000;
    border: none;
    padding: 0;
    font: inherit;
    cursor: pointer;
    outline: inherit;
  }
  .socialm {
    display: none;
  }
  .toggleContainer{
    width: 30px;
  }
  @media only screen and (max-width: 1246px) {
    display: block;

    .pages,
    .pages a {
      position: relative;
      display: block;
    }
    min-height: 72px;
    .pages a {
      margin-left: 30px;
      margin-bottom: 40px;
    }
    .toggleContainer{
      width: 100%;
    }
    .toggleContainer .togBtn {
      margin: auto;
      margin-right: 30px;
    }
    .navTogglebtnOpen.open,
    .navTogglebtnClose.open {
      display: block;
    }
    .navTogglebtnOpen.close,
    .navTogglebtnClose.close {
      display: none;
    }
    .toggleContainer,
    .branding {
      display: flex;
      vertical-align: middle;
      justify-content: right;
    }
    .pages.close {
      display: none;
    }
    .socialm {
      display: inline-block !important;
      margin: 0px;
      margin-bottom: 15px;
    }
    .logo {
      width: 300px;

      max-width: 386px;
      padding-left: 0px;
      padding-top: 30px;
      padding-bottom: 20px;
    }
  }
  @media only screen and (max-width: 760px) {
    min-height: 72px;
  }
  @media only screen and (max-width: 768px) and (max-height: 1024px) {
    min-height: 72px;
    .logo {
      width: 200px;
      max-width: 200px;
    }
  }
  @media only screen and (max-width: 414px) and (max-height: 736px) {
    .logo {
      width: 200px;
      max-width: 200px;
    }
  }
  @media only screen and (max-width: 411px) and (max-height: 823px) {
    .logo {
      width: 200px;
      max-width: 200px;
    }
  }
  @media only screen and (max-width: 411px) and (max-height: 731px) {
    .logo {
      width: 200px;
      max-width: 200px;
    }
  }
  @media only screen and (max-width: 400px) {
    .logo {
      width: 200px;
      max-width: 200px;
    }
    .toggleContainer .togBtn {
      margin-right: 10px;
      margin-left: 50px;
    }
  }
  @media only screen and (min-width: 486px) {
    .branding {
      margin: auto;
      margin-left: 30px;
    }
  }
  @media only screen and (max-width: 280px) {
    .logo {
      width: 150px;
      max-width: 150px;
    }
  }
`;
